import { Injectable, Inject, Optional } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";

import { CommonService } from "./common.service";
import { MessageService } from "./message.service";

import { environment } from "../../environments/environment";

@Injectable()
export class OutputService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) {}

  private httpOptions = this.commonService.httpOptions;
  private Options = this.commonService.Options;

  /**
   * 出力履歴レコード取得
   * @param eid イベントID
   */
  getOutputHistory(eid) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl + "/api/output/output_history_list/" + eid,
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("output_history_list", []))
      );
  }

  /**
   * 個別出力・一括出力での登録・実行処理
   * @param param
   */
  execOutput(param: any) {
    return this.http
      .post(
        environment.apiUrl +
          "/api/customize/" +
          param.class_nm +
          "/output_start",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("output_start", []))
      );
  }

  /**
   * 1ファイルのダウンロード処理
   * @param param
   */
  execOutputSingle(param: any) {
    // this.commonService.get_file(environment.apiUrl+'/api/output/output_file',param);
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl +
          "/api/customize/" +
          param.class_nm +
          "/output_start",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("output_start", []))
      );
  }

  /**
   * ダウンロード直前でのファイルの存在確認
   * @param param 出力を行うHistoryId
   */
  checkExistsFile(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/output/check_exists",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("check_exists", []))
      );
  }

  /**
   * 個別出力・一括出力でのダウンロード処理
   * ※ZIPでの ダウンロード処理
   * @param param
   */
  downloadFile(param: any) {
    this.commonService.get_file(
      environment.apiUrl + "/api/output/downloadFile",
      param
    );
  }

  /**
   * キャンセル処理
   * @param param
   */
  cancelOutput(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/output/cancel", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("cancel", []))
      );
  }
  /**
   * 1ファイルのダウンロード処理
   * @param param
   * 未確認
   */
  pdfDownload(param: any) {
    this.commonService.get_file(
      environment.apiUrl + "/api/output/inoculation/inoculationPdf",
      param
    );
  }
  /**
   * 1ファイルのダウンロード処理
   * @param param
   * 未確認
   */
  execOutputCertificate(param: any) {
    // this.commonService.get_file(environment.apiUrl+'/api/output/output_file',param);
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/output/inoculation/output_start",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("output_start", []))
      );
  }
  /**
   * 結果表出力
   * @param param
   * 未確認
   */
  downloadKekkaPdf(param: any) {
    this.commonService.get_file(
      environment.apiUrl + "/api/output/download_pdf",
      param
    );
  }

  /**
   * 出力するイベントの一覧を取得
   * @param m_user_id ユーザーID
   * kekka-downloadより
   */
  getKekkaDownloadEvent() {
    this.commonService.loadingStart();
    return this.http
      .get(environment.apiUrl + "/api/kekkainfo/kenshininfo", this.httpOptions)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("kenshininfo", []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/output.service.ts